import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {getDTimes, getdate,gettime,getRequest,deleteRequest,postRequest,postRequestp,patchRequest,postForm,SysMessage,MEDIA_URL} from "./utils/api";
import CryptoJS from 'crypto-js'
import { desParam, getDesKey } from "./utils/security"

Vue.use(CryptoJS);
Vue.use(ElementUI);

Vue.prototype.desParam = desParam;
Vue.prototype.getDesKey = getDesKey;
Vue.prototype.getDTimes = getDTimes;
Vue.prototype.getdate = getdate;
Vue.prototype.gettime = gettime;
Vue.prototype.getRequest = getRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.postRequestp = postRequestp;
Vue.prototype.patchRequest = patchRequest;
Vue.prototype.postForm = postForm;
Vue.prototype.SysMessageError = SysMessage;
Vue.prototype.MEDIA_URL = MEDIA_URL;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
